import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { AbstractFeatureEntityStore } from '@y42/feature';
import { ExportGitFactoryService } from './export-git-factory.service';
import { ExportState } from './export.model';

const initialState: ExportState = {
  loading: true,
  last_used: {},
  starred: {},
  ui: {},
  active: null,
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'export', idKey: '$path' })
export class ExportStore extends AbstractFeatureEntityStore<ExportState> {
  constructor(protected readonly gitFactory: ExportGitFactoryService) {
    super({
      name: 'Export',
      gitFactory,
      initialState,
    });
  }
}
